<div class="custom-tab-wrapper my-4">
  <div class="custom-tab-buttons">
    <button [ngClass]="{ active: selectedTab === 0 }" (click)="selectedTab = 0">
      Unprocessed
    </button>
    <button [ngClass]="{ active: selectedTab === 1 }" (click)="selectedTab = 1">
      Processed
    </button>

    <button [ngClass]="{ active: selectedTab === 2 }" (click)="selectedTab = 2">
      More than 1 Child
    </button>
  </div>

  <div class="custom-tab-content">
    <ng-container [ngSwitch]="selectedTab">
      <insider-relationship-app-unprocessed
        *ngSwitchCase="0"
      ></insider-relationship-app-unprocessed>
      <insider-relationship-app-processed
        *ngSwitchCase="1"
      ></insider-relationship-app-processed>
      <app-more-than-one-child *ngSwitchCase="2"></app-more-than-one-child>
    </ng-container>
  </div>
</div>
